import { createSelector } from "reselect";

const getCancerHotspots = (state) =>
  state.variantResult && state.variantResult.cancer_hotspots;

const getCancerHotspotsData = createSelector(
  getCancerHotspots,
  (cancerHotspots) => cancerHotspots && cancerHotspots[0]
);

export { getCancerHotspotsData };
